type NotNullableObject<T> = { [P in keyof T]: NonNullable<T[P]> };

export function removeObjectUndefinedOrNullValues<T extends object>(obj: T): NotNullableObject<T> {
  const keys = Object.keys(obj) as Array<keyof T>;
  return keys.reduce<NotNullableObject<T>>(
    (acc, key) => (obj[key] != null ? { ...acc, [key]: obj[key] } : acc),
    {} as NotNullableObject<T>,
  );
}
